module.exports = __webpack_public_path__ + "assets/img/script_props_define.8e24b3c4.jpg";